import React from "react";
import {chevronDown, chevronUp} from "ionicons/icons";
import {IonButton, IonIcon} from "@ionic/react";
import {Alert, AlertTitle} from "@mui/material";
import './Explanation.css';
import {WithTranslation, withTranslation} from "react-i18next";

/**
* Interface inheriting the translation module.
* We put all the props of the component there.
**/
interface Props extends WithTranslation {
    /**
     * Alert content (displays when the accordion is open).
     */
    children: React.ReactNode
}

/**
 * Displays an information alert with customizable content.
 * Uses an accordion system.
 * @author Alizée Grand
 * @version 1.0
 * @creation 20/04/2022
 * @last_update 20/04/2022
 **/
class Explanation extends React.Component<Props> {

    state = {
        isExplanationVisible: false
    }

    render() {

        /**
         * Returns the adapted icon according to the opening of the accordion.
         * @return {JSX.Element} Icon representing an up arrow when the accordion is open and a down arrow when it is closed.
         */
        const getIconButton = () => {
            let icon = this.state.isExplanationVisible ? chevronUp : chevronDown;
            return (<IonIcon icon={icon}/>);
        };

        /**
         * Changes the opening of the accordion (opens it when it is closed and vice versa).
         */
        const changeAccordionOpening = () => {
            this.setState({isExplanationVisible: !this.state.isExplanationVisible});
        }

        return (
            <Alert
                id="explanation-alert"
                onClick={changeAccordionOpening}
                severity="info"
                action={
                    <IonButton id='explanation-icon-button' onClick={changeAccordionOpening}>
                        {
                            getIconButton()
                        }
                    </IonButton>
                }
            >
                <AlertTitle>{this.props.t('utils.alert.explanation.title')}</AlertTitle>
                {
                    this.state.isExplanationVisible ? (
                        <p className="explanation-content">
                            {this.props.children}
                        </p>
                    ) : ""
                }
            </Alert>
        );
    };

}

export default withTranslation()(Explanation);
